import { ArrowLeft } from "lucide-react";
import { ORG, WHATSAPP_URL } from "@/config/site";

const SECTIONS = [
  {
    title: "What We Collect",
    body: "When you use the BGNZN Institute website and SMS ledger program we collect only what the service requires: your name, mobile phone number, the content of payment command texts you send (e.g., SEND 50 TO MEMBER_B), and the resulting transaction confirmations. Website visits log standard technical data (browser type, pages visited) for security and reliability.",
  },
  {
    title: "How We Use It",
    body: "Your phone number and message content are used exclusively to authenticate your device, execute ledger transfers you request, and send you transactional settlement confirmations. We do not use your information for advertising, profiling, or any purpose outside the cooperative's clearing services.",
  },
  {
    title: "Sharing",
    body: "We do not sell, rent, or share your personal information or SMS data with third parties for marketing. The sole processor is Twilio, Inc., which carries the text messages as our telecommunications carrier platform. Ledger records are held on the Institute's private infrastructure and are not published to any public blockchain or database.",
  },
  {
    title: "SMS Data Specifically",
    body: "No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Text messaging originator opt-in data and consent records are kept private and are never sold. Message frequency varies. Message and data rates may apply. You can reply STOP to any message to end alerts immediately, or HELP for assistance.",
  },
  {
    title: "Retention & Security",
    body: "Payment records are retained as part of the cooperative's private clearing ledger. Opt-in consent records are kept while your membership is active. All transmissions to this site are encrypted in transit (TLS), and ledger payloads are additionally sealed with AES-256 encryption at rest.",
  },
  {
    title: "Your Controls",
    body: "Reply STOP to any text to opt out instantly. To review, correct, or delete your personal records, contact the Institute through the WhatsApp membership channel listed in the site footer.",
  },
];

const Privacy = () => (
  <div data-testid="privacy-page" className="min-h-screen bg-stone-950 text-stone-200">
    <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
      <div className="space-y-4">
        <a href="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-stone-500 hover:text-amber-500 transition-colors">
          <ArrowLeft size={13} /> Return to the Institute
        </a>
        <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">Legal</span>
        <h1 className="text-4xl font-bold tracking-tight text-stone-100 display-serif">Privacy Policy</h1>
        <p className="text-stone-500 text-xs uppercase tracking-widest">{ORG.name} · Effective October 2026</p>
      </div>
      {SECTIONS.map((s) => (
        <div key={s.title} className="space-y-2">
          <h2 className="text-base font-bold text-stone-100">{s.title}</h2>
          <p className="text-sm text-stone-400 leading-relaxed">{s.body}</p>
        </div>
      ))}
      <p className="text-xs text-stone-600 border-t border-stone-900 pt-6">
        Questions about this policy: reach the Institute via{" "}
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:text-amber-400">
          the WhatsApp membership channel
        </a>
        .
      </p>
    </div>
  </div>
);

export default Privacy;
